<div class="w-full h-fit flex flex-col" *ngIf="!loading">

    <div *ngIf="!loading">
        <div class="w-full" *ngIf="dealPageBanners?.length >= 1">
          <app-swiper-packages [Packages]="dealPageBanners" [DealsPage]="true"></app-swiper-packages>
        </div>

        <!-- Body -->
        <section>
            <div class="flex-wrap justify-center my-10 max-sm:my-8 px-4 flex-shrink-0">
              <div class="flex flex-wrap justify-center info-blocks-container flex-shrink-0 md:space-x-12 max-sm:space-y-12">
                
                <div class="w-full">
                  <div>
                    <div class="text-primary text-4xl font-extrabold">
                        Deals
                    </div>
                  </div>
          
                  <hr class="my-5">
          
                  <div class="w-full pb-10 py-4">
                    <p class="text-black text-lg font-bold">
                        {{description}}             
                    </p>
                  </div>
          
                </div>

                <div class="w-full flex flex-col">
                  <ng-container *ngFor="let dct of dealsCategoryTypes" class="py-4">
                    <div class="flex flex-col text-2xl font-extrabold">
                      {{dct.title}}
                    </div>
                    
                    <hr class="my-5">

                    <div class="flex flex-wrap items-center w-full gap-10">
                      <div *ngFor="let d of deals[dct.title]">
                        <fuse-card class="hover:cursor-pointer max-sm:w-[350px] w-90  mb-4 flex flex-col max-sm:p-0 p-4 rounded-3xl shadow-md max-sm:items-center items-start justify-center drop-shadow-lg transition ease-in-out hover:-translate-y-2 duration-300" (click)="this._router.navigate(['/home']);">
                          <img [src]="d.image[0]?.url" alt="deals image" loading="lazy">
                        </fuse-card>
                      </div>

                    </div>

                    
                </ng-container>
              </div>
      
                
                
              </div>

             
            </div>

    </section>

    




</div>
